export const defaultValue = {
    id: '',
    departmentName: '',
    description: '',
    supervisorUsername: '',
    departmentHeadUsername: '',
    supervisor: null,
    departmentHead: null,
    departmentMembers: [],
    memberUsernames: [],
    active: true,
    createdBy: '',
    createdDate: null,
    lastModifiedBy: '',
    lastModifiedDate: null,
};
/** Resolve login/username from API string or nested user object. */
export function departmentUsernameFromValue(value) {
    if (value == null || value === '')
        return '';
    if (typeof value === 'string')
        return value.trim();
    if (typeof value === 'object') {
        const u = value;
        return (u.username ?? u.login ?? '').trim();
    }
    return String(value).trim();
}
export function departmentDisplayName(dept) {
    return (dept.departmentName ?? dept.name ?? '').trim();
}
export function departmentMemberCount(dept) {
    if (typeof dept.activeMembersCount === 'number')
        return dept.activeMembersCount;
    const members = dept.departmentMembers ?? dept.members ?? [];
    return members.length;
}
export function departmentWorkload(dept) {
    return dept.currentCaseCount ?? 0;
}
export function departmentMembersFromEntity(dept) {
    if (!dept)
        return [];
    const fromUsernames = (dept.memberUsernames ?? []).map((username) => ({
        username: username.trim(),
        name: username.trim(),
    }));
    const rawMembers = dept.departmentMembers ?? dept.members ?? [];
    const fromObjects = rawMembers.flatMap((member) => {
        const username = departmentUsernameFromValue(member);
        if (!username)
            return [];
        return [
            {
                username,
                name: (member.name ?? username).trim(),
                position: member.position?.trim(),
            },
        ];
    });
    const merged = [...fromObjects, ...fromUsernames];
    const seen = new Set();
    return merged.filter((member) => {
        if (seen.has(member.username))
            return false;
        seen.add(member.username);
        return true;
    });
}
export function toDepartmentWritePayload(data) {
    const payload = {
        name: data.departmentName.trim(),
        description: (data.description ?? '').trim(),
        active: data.active,
        supervisorUsername: (data.supervisorUsername ?? '').trim(),
        departmentHeadUsername: (data.departmentHeadUsername ?? '').trim(),
    };
    if (data.memberUsernames != null) {
        payload.members = data.memberUsernames
            .map((username) => username.trim())
            .filter(Boolean)
            .map((username) => ({ username }));
    }
    return payload;
}
